module.exports = __webpack_public_path__ + "static/7-2928a34b486a1a50819111556db8cb66.jpg";